import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { BellRing } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HotLeadAlertSettings = () => {
  const [email, setEmail] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/ai/admin/alert-settings`).then((res) => setEmail(res.data.email || "")).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/ai/admin/alert-settings`, { email: email.trim() || null });
      toast.success(email.trim() ? "Alertes activées" : "Alertes désactivées");
    } catch (e) {
      toast.error("Adresse email invalide");
    }
    setSaving(false);
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 p-3 rounded-xl bg-red-50 border border-red-100">
      <div className="flex items-center gap-2 text-sm text-red-700 font-medium flex-shrink-0">
        <BellRing className="w-4 h-4" /> Alerte prospect chaud par email
      </div>
      <Input
        type="email"
        placeholder="votre@email.fr (vide = désactivé)"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="bg-white"
        data-testid="hot-lead-alert-email-input"
      />
      <Button size="sm" onClick={save} disabled={saving} className="bg-[#102692] hover:bg-[#0d1f75]" data-testid="hot-lead-alert-save-btn">
        Enregistrer
      </Button>
    </div>
  );
};
